<ng-container *transloco="let t;">
    <mat-toolbar class="tool-bar">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center" style="background-color: #ea7600;">
            <h1 fxFlex style="color: white;">{{ t('DocumentArchive.history') }}</h1>
            <button style="color: white;" mat-icon-button class="close-button" style="margin-left: 272px;">
                <mat-icon (click)="dialogRef.close()">close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div>
        <mat-dialog-content>
            <table mat-table [dataSource]="data.documentVersions" class="mat-elevation-z1">

                <!-- Version Column -->
                <ng-container matColumnDef="version">
                    <th mat-header-cell *matHeaderCellDef>Version</th>
                    <td mat-cell *matCellDef="let element">{{ element.versionNumber }}</td>
                </ng-container>

                <!-- File Name Column -->
                <ng-container matColumnDef="fileName">
                    <th mat-header-cell *matHeaderCellDef>File Name</th>
                    <td mat-cell *matCellDef="let element">{{ element.fileName }}</td>
                </ng-container>

                <!-- Uploaded By Column -->
                <ng-container matColumnDef="uploadedBy">
                    <th mat-header-cell *matHeaderCellDef>Uploaded By</th>
                    <td mat-cell *matCellDef="let element">{{ element.uploadedBy }}</td>
                </ng-container>

                <!-- Date Created Column -->
                <ng-container matColumnDef="dateCreated">
                    <th mat-header-cell *matHeaderCellDef>Date</th>
                    <td mat-cell *matCellDef="let element">{{ element.dateCreated }}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let element">{{ element.status }}</td>
                </ng-container>

                <ng-container matColumnDef="comments">
                    <th mat-header-cell *matHeaderCellDef>Comments</th>
                    <td mat-cell *matCellDef="let element" class="comment-cell" [matTooltip]="element.comments">
                        {{ element.comments }}
                    </td>
                </ng-container>

                <tr mat-header-row
                    *matHeaderRowDef="['version', 'fileName', 'uploadedBy', 'dateCreated', 'status', 'comments']"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: ['version', 'fileName', 'uploadedBy', 'dateCreated', 'status', 'comments'];">
                </tr>
            </table>
        </mat-dialog-content>
        <div fxLayout="row" class="dialog-actions">
            <button mat-stroked-button color="primary" (click)="dialogRef.close()">
                {{ t('siteInspection.Cancel') }}
            </button>
        </div>
    </div>
</ng-container>